import React from 'react';

import AiChatIcon from '@atlaskit/icon/core/ai-chat';

export const ChatIcon = () => <AiChatIcon label="" spacing="spacious" />;
